import React from 'react';
import { injectStripe } from 'react-stripe-elements';
import CardSection from './CardSection';
import { Context } from '../../Context';

class CardDetails extends React.Component {
	constructor() {
		super();
		this.state = { loading: false };
	}

	handleSubmit = async (ev) => {
		ev.preventDefault();

		console.log('Stripe event', ev, this.props.stripe, this.context);

		this.setState({ loading: true });

		const { source, error } = await this.props.stripe.createSource({
			type: 'card',
			owner: {
				name: `${this.context.state.user.firstName} ${this.context.state.user.lastName}`,
				email: this.context.state.user.email
			}
		});

		if (source) {
			console.log('stripe source', source);

			this.context.actions.addStripeSource(source, () => {
				console.log('return from adding source');

			})
		}
		if (error) {
			console.log('stripe error', error);

			this.context.actions.setState({ error: error.message });
		}

		this.setState({ loading: false });


	};

	render() {
		return (
			<div>
				<form onSubmit={this.handleSubmit}>
					<CardSection loading={this.state.loading} />
				</form>
			</div>
		);
	}
}

CardDetails.contextType = Context;

export default injectStripe(CardDetails);